module.exports = __webpack_public_path__ + "static/media/RPA.8a67910b.png";